<template>
 <el-dialog
      :title="$t('socialMedia.infoMediaType')"
      :visible="visible"
      width="45%"
      @close="handleCancel"
      :close-on-click-modal="false">
    <span>{{$t('socialMedia.infoMediaTypeText')}}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">{{$t('socialMedia.infoMediaTypeButton1')}}</el-button>
      <el-button type="primary" @click="handleConfirm">{{$t('socialMedia.infoMediaTypeButton2')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'DialogMediaWarning',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleCancel () {
      this.$emit('cancel')
    },
    handleConfirm () {
      this.$emit('confirm')
    }
  }
}
</script>
